"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewsPostCard = NewsPostCard;
Object.defineProperty(exports, "alertIcon", {
  enumerable: true,
  get: function () {
    return _newsPostAlert.default;
  }
});
exports.newsPostsIcons = void 0;
var _Menu2 = _interopRequireDefault(require("@mui/material/Menu"));
var _MenuItem2 = _interopRequireDefault(require("@mui/material/MenuItem"));
var _ListItemText2 = _interopRequireDefault(require("@mui/material/ListItemText"));
var _ListItemIcon2 = _interopRequireDefault(require("@mui/material/ListItemIcon"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _MoreHoriz2 = _interopRequireDefault(require("@mui/icons-material/MoreHoriz"));
var _ButtonBase2 = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Avatar2 = _interopRequireDefault(require("@mui/material/Avatar"));
var _styles = require("@mui/material/styles");
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _challengeEnd = _interopRequireDefault(require("../assets/images/news/challenge-end.svg"));
var _challengeStart = _interopRequireDefault(require("../assets/images/news/challenge-start.svg"));
var _newsPostAlert = _interopRequireDefault(require("../assets/images/news/news-post-alert.svg"));
var _objective = _interopRequireDefault(require("../assets/images/news/objective-100.svg"));
var _objective2 = _interopRequireDefault(require("../assets/images/news/objective-25.svg"));
var _objective3 = _interopRequireDefault(require("../assets/images/news/objective-50.svg"));
var _objective4 = _interopRequireDefault(require("../assets/images/news/objective-75.svg"));
var _topRanking = _interopRequireDefault(require("../assets/images/news/top-ranking.svg"));
var _components = require("../components");
var _services = require("../services");
var _removePostDialog = require("./remove-post-dialog");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const newsPostsIcons = exports.newsPostsIcons = {
  challengeEnd: _challengeEnd.default,
  challengeObjective100: _objective.default,
  challengeObjective25: _objective2.default,
  challengeObjective50: _objective3.default,
  challengeObjective75: _objective4.default,
  challengeStart: _challengeStart.default,
  challengeTopRanking: _topRanking.default,
  manual: _newsPostAlert.default
};
function NewsPostCard({
  Dialog,
  Link,
  small,
  currentPartner,
  currentUser,
  geogroup,
  userType,
  editPath,
  newsPost,
  onEdit,
  onRemoved
}) {
  const [photosDialogOpen, openPhotosDialog] = (0, _react.useState)(false);
  const [showedPhotos, showPhotos] = (0, _react.useState)(null);
  const [settingsMenuAnchorEl, setSettingsMenuAnchorEl] = (0, _react.useState)(null);
  const [removeDialogOpen, openRemoveDialog] = (0, _react.useState)(false);
  const [liking, setLiking] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    transitions
  } = (0, _styles.useTheme)();
  function handlePhotosDialogOpen() {
    if (!newsPost || !newsPost.photo) return;
    showPhotos([{
      url: `${_services.AppService.environment.backendUrl}${newsPost.photo}`
    }]);
    openPhotosDialog(true);
  }
  function handlePhotosDialogClose() {
    openPhotosDialog(false);
    setTimeout(() => showPhotos(null), transitions.duration.leavingScreen);
  }
  async function handleLike() {
    if (!newsPost) return;
    setLiking(true);
    try {
      if (!newsPost.liked) {
        await _services.GeogroupService.likeNewsPost({
          newsPostId: newsPost.id
        });
        newsPost.liked = true;
        newsPost.likesCount = (newsPost.likesCount || 0) + 1;
      } else {
        await _services.GeogroupService.unlikeNewsPost({
          newsPostId: newsPost.id
        });
        newsPost.liked = false;
        newsPost.likesCount = (newsPost.likesCount || 0) - 1;
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('commons.news.server_error_like'));
    }
    setLiking(false);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "flex-start",
    display: "flex",
    gap: 5
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignSelf: "stretch",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1.5
  }, newsPost ? newsPost.postedByGroup ? /*#__PURE__*/_react.default.createElement(_components.GeogroupAvatar, {
    geogroup: newsPost.geogroup
  }) : newsPost.creator ? /*#__PURE__*/_react.default.createElement(_components.UserAvatar, {
    user: newsPost.creator
  }) : /*#__PURE__*/_react.default.createElement(_Avatar2.default, {
    sx: ({
      palette
    }) => ({
      bgcolor: palette.primary.light,
      height: 32,
      width: 32
    })
  }, /*#__PURE__*/_react.default.createElement(_components.PersonIcon, {
    fontSize: "small",
    sx: {
      color: '#fff'
    }
  })) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: 32,
    variant: "circular",
    width: 32
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 0.5
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    lineHeight: 1,
    variant: "body2"
  }, newsPost ? newsPost.postedByGroup ? newsPost.geogroup?.title || '' : newsPost.creator ? newsPost.creator.username : /*#__PURE__*/_react.default.createElement("i", null, t('commons.news.deleted_user')) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 150
  })), newsPost?.postedByGroup && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    alignSelf: "flex-start",
    bgcolor: "#F3F6FF",
    borderRadius: 4,
    color: "#326ac2",
    display: "flex",
    gap: 0.5,
    paddingX: 1,
    paddingY: 0.5
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    lineHeight: 1,
    variant: "caption"
  }, "Admin"))), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "caption"
  }, newsPost ? newsPost.created.format('LL') : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })))), newsPost ? newsPost.photo && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    component: _ButtonBase2.default,
    display: small ? 'block' : {
      xs: 'block',
      md: 'none'
    },
    flexShrink: 0,
    onClick: handlePhotosDialogOpen,
    width: 200
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: `${_services.AppService.environment.backendUrl}${newsPost.photo}`,
    width: 200
  })) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: small ? 'block' : {
      xs: 'block',
      md: 'none'
    },
    flexShrink: 0,
    width: 200
  }, /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: 150,
    variant: "rounded",
    width: 200
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    component: "div",
    sx: {
      '> div > p': {
        margin: 0
      }
    },
    variant: "body2"
  }, newsPost ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    dangerouslySetInnerHTML: {
      __html: newsPost.text
    }
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: "100%"
  }), /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: "90%"
  })))), newsPost?.link && /*#__PURE__*/_react.default.createElement(_Box2.default, null, /*#__PURE__*/_react.default.createElement(_components.Button, {
    color: "primary",
    component: "a",
    href: newsPost.link?.url,
    rel: "noreferrer",
    size: "small",
    startIcon: /*#__PURE__*/_react.default.createElement(_components.LinkIcon, null),
    target: "_blank",
    variant: "text"
  }, newsPost.link?.label || t('commons.news.link')))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, newsPost && currentUser !== undefined ? currentUser && /*#__PURE__*/_react.default.createElement(_components.Button, {
    color: "inherit",
    disabled: liking,
    onClick: handleLike,
    size: "small",
    startIcon: newsPost.liked ? /*#__PURE__*/_react.default.createElement(_components.LikeIcon, null) : /*#__PURE__*/_react.default.createElement(_components.LikeOulinedIcon, null)
  }, newsPost.likesCount || 0) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: 30,
    variant: "rounded",
    width: 64
  }), newsPost && (userType === 'admin' || currentUser && newsPost.creator && newsPost.creator.id === currentUser.id) && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "right",
    title: t('commons.settings')
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    disabled: !newsPost,
    onClick: ({
      currentTarget
    }) => setSettingsMenuAnchorEl(currentTarget),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_MoreHoriz2.default, {
    color: "action",
    fontSize: "small"
  }))))), newsPost && /*#__PURE__*/_react.default.createElement(_Menu2.default, {
    anchorEl: settingsMenuAnchorEl,
    onClose: () => setSettingsMenuAnchorEl(null),
    open: Boolean(settingsMenuAnchorEl),
    slotProps: {
      root: {
        sx: {
          '.MuiBackdrop-root': {
            bgcolor: 'initial'
          }
        }
      },
      paper: {
        sx: {
          borderRadius: 2
        }
      }
    }
  }, newsPost.type === 'manual' && (userType === 'admin' && newsPost.postedByGroup || currentUser && newsPost.creator && newsPost.creator.id === currentUser.id) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Link && !onEdit && editPath && /*#__PURE__*/_react.default.createElement(_MenuItem2.default, {
    dense: true,
    component: Link,
    to: editPath
  }, /*#__PURE__*/_react.default.createElement(_ListItemIcon2.default, null, /*#__PURE__*/_react.default.createElement(_components.EditIcon, null)), /*#__PURE__*/_react.default.createElement(_ListItemText2.default, {
    primary: t('commons.actions.edit')
  })), onEdit && /*#__PURE__*/_react.default.createElement(_MenuItem2.default, {
    dense: true,
    onClick: () => {
      setSettingsMenuAnchorEl(null);
      onEdit();
    }
  }, /*#__PURE__*/_react.default.createElement(_ListItemIcon2.default, null, /*#__PURE__*/_react.default.createElement(_components.EditIcon, null)), /*#__PURE__*/_react.default.createElement(_ListItemText2.default, {
    primary: t('commons.actions.edit')
  }))), /*#__PURE__*/_react.default.createElement(_MenuItem2.default, {
    dense: true,
    onClick: () => {
      setSettingsMenuAnchorEl(null);
      openRemoveDialog(true);
    }
  }, /*#__PURE__*/_react.default.createElement(_ListItemIcon2.default, null, /*#__PURE__*/_react.default.createElement(_components.RemoveIcon, {
    color: "error"
  })), /*#__PURE__*/_react.default.createElement(_ListItemText2.default, {
    primary: t('commons.actions.remove')
  })))), newsPost ? newsPost.photo && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    component: _ButtonBase2.default,
    display: small ? 'none' : {
      xs: 'none',
      md: 'block'
    },
    flexShrink: 0,
    onClick: handlePhotosDialogOpen,
    width: 200
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: `${_services.AppService.environment.backendUrl}${newsPost.photo}`,
    width: 200
  })) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: small ? 'none' : {
      xs: 'none',
      md: 'block'
    },
    flexShrink: 0,
    width: 200
  }, /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: 150,
    variant: "rounded",
    width: 200
  }))), /*#__PURE__*/_react.default.createElement(_components.PhotosDialog, {
    onClose: handlePhotosDialogClose,
    open: photosDialogOpen,
    photos: showedPhotos
  }), newsPost && /*#__PURE__*/_react.default.createElement(_removePostDialog.RemovePostDialog, {
    currentPartner: currentPartner,
    Dialog: Dialog,
    geogroup: geogroup,
    handleClose: removed => {
      openRemoveDialog(false);
      if (removed) onRemoved?.();
    },
    newsPost: newsPost,
    open: removeDialogOpen
  }));
}